var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.field.metadata && _vm.field.metadata.description)?_c('p',[_vm._v(" "+_vm._s(_vm.field.metadata.description)+" ")]):_vm._e(),_c('v-switch',{attrs:{"inset":"","label":_vm.field.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }